export const environment = {
  production: false,
  api: 'https://api-prod.senaapps.com/api',
  websocketUrl: 'https://websocket.senaapps.com',
  websocketUrlStatusMachine: 'https://websocket-status-machine.senaapps.com',
};
